import React from 'react';
import { Image, ImageSizes } from '../../../caravan-details-page/types';
import styles from './content-picture.module.scss';

interface Props {
  image: Image;
  className?: string;
  size?: keyof ImageSizes;
}

export const ContentPicture = ({ image, className, size = 'defaultSrc' }: Props) => {
  const imgUrl = image.sizes?.[size] || image.sizes?.defaultSrc;

  return (
    <picture className={className}>
      {imgUrl ? <img src={imgUrl} alt={image.altText} /> : <div className={styles.placeholder} />}
    </picture>
  );
};
